<!-- <ion-content> -->
<!-- Body Content-->
<div class="pt-2 md:px-4 mb-8 pb-6 relative z-2 safe-area-margin">
  <!-- Page Header -->

  <div class="lg:flex align-items-center justify-content-between mb-2">

      <!-- Left Side -->
      <div class="lg:block flex align-items-center justify-content-between px-3 md:px-0">
          <h1 class="text-base md:text-lg text-900 mb-0 flex align-items-center">
              {{'Shared.PIPELINE.SALES_PIPELINE' | translate}}
              <!-- <i [pTooltip]="'Shared.PIPELINE.SALES_TOOL_TIP' | translate" tooltipStyleClass="text-xs" class="fa fa-circle-question text-600 ml-2 cursor-pointer"></i> -->
              <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="https://guides.unifiedfitnessplatform.ai/showcase/cluihdrd007o94l520jxr4e4e" target="_blank">
            <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
            <span class="ml-2 hidden md:inline-block">Help Guide for {{'Shared.PIPELINE.SALES_PIPELINE' | translate}}</span>
            </a>
          </h1>
          <div class="flex justify-content-end lg:hidden">
            <div (click)="showCreateOpportunityPopup = true;">
              <p-button icon="fa fa-plus" aria-label="create-opportunity-button"></p-button>
            </div>
            <p-button icon="fa fa-filter" styleClass="ml-2 surface-0 p-button-outlined p-button-secondary" pStyleClass=".search-staff" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true" aria-label="filter-button"></p-button>
          </div>
      </div>
      <!-- Left Side -->

      <!-- Right Side -->
      <div class="hidden lg:block search-staff lg:flex-order-1 mt-2 -mb-2 lg:my-0">
        <div class="lg:flex align-items-center justify-content-center xl:justify-content-end">
            <div class="lg:w-12rem p-2 lg:p-0 surface-0">
                <multi-select-staff [selected]="selectedStaffIds" (selectStaffEvent)="selectedStaffsData($event)"> </multi-select-staff>
            </div>
            <div (click)="showCreateOpportunityPopup = true;" class="hidden xl:inline-block">
              <p-button [label]="'Shared.PIPELINE.CREATE_OPPORTUNITY' | translate" icon="fa fa-plus" styleClass="text-sm ml-3" aria-label="create-opportunity-button"></p-button>
            </div>
        </div>
      </div>
      <!-- Right Side -->

      <!-- Center Side -->
      <div class="xl:flex align-items-center justify-content-center relative">
        <div class="p-buttonset flex md:justify-content-center px-3 md:px-0 xl:-ml-8 mt-2 lg:mt-0">
          <button [ngClass]="showPipelineView.value ? 'bg-primary' : 'surface-600' " (click)="ChangeView(showPipelineView.value,showForecastView.value)" pButton pRipple label="Pipeline view" class="border-none text-sm" aria-label="pipeline-view-button"></button>
          <button [ngClass]="showForecastView.value ? 'bg-primary' : 'surface-600' " (click)="ChangeView(showPipelineView.value,showForecastView.value)" pButton pRipple label="Forecast view" class="surface-600 border-none text-sm border-left-2 border-white" aria-label="forecast-view-button"></button>
        </div>
          <div *ngIf="showForecastView.value" class="xl:absolute left-0 white-space-nowrap xl:ml-11rem mt-2 xl:mt-0 flex align-items-center md:justify-content-center px-3">
            <p-checkbox *ngIf="showForecastView.value" [label]="'Shared.PIPELINE.HIDE_MONTHS' | translate" [(ngModel)]="hideMonth" [binary]="true" inputId="binary" [value]="hideMonth" (onChange)="filterData($event);" aria-label="hide-months-checkbox"></p-checkbox>
         </div>
          
      </div>
      <!-- Center Side -->

  </div>
  <!-- Page Header -->

  <!-- Cards -->
  <div class="pb-4 overflow-x-auto -mr-4" #Container cdkScrollable *ngIf="!(showEmptyPipeline$ | async)" [ngClass]="(allOpportunity | async) > 0 ? 'sales-pipeline-cards-wrap': 'sales-pipeline-cards-wrap-no-data'">
      <div class="flex flex-nowrap -mb-4 md:-mb-3 sales-pipeline-column-wrapper sticky top-0" *ngIf="!showSkeleton; else showSkeletonStage">
          <ng-container *ngIf="showPipelineView.value">
              <!-- Cards Column -->
              <div class="w-24rem mr-3 sales-pipeline-cards-column shadow-2" *ngFor="let board of (opportunityData$.asObservable() | async)">
                  <!-- Card Header -->
                  <ng-container *ngIf="board">
                      <div class="card-header surface-0 p-3 border-round-top flex align-content-center">
                          <div class="w-6">
                              <h3 class="text-sm mb-0">{{'OPPORTUNITY.OPPORTUNITYSTAGE.' + board.name_primary_language.toUpperCase() | translate}}</h3>
                          </div>
                          <div class="w-6 text-right white-space-nowrap">
                              <h3 class="mb-0 text-sm">
                                  {{valueInMinorCurrency(board.id) | currencyformat}}
                                  <span class="text-600 font-normal text-sm">{{board?.opportunity?.length | number}} {{'Shared.PIPELINE.DEALS' | translate}} </span>
                              </h3>
                          </div>
                      </div>
                  </ng-container>
                  <!-- Card Header -->
              </div>
              <!-- Cards Column -->
          </ng-container>

          <ng-container *ngIf="showForecastView.value">
              <!-- Cards Column -->
              <div class="w-24rem mr-3 sales-pipeline-cards-column shadow-2" *ngFor="let month of this.filterMonths$.value">
                  <!-- Card Header -->
                  <ng-container *ngIf="month">
                      <div class="card-header surface-0 p-3 border-round-top flex align-content-center">
                          <div class="w-6">
                              <h3 class="text-sm mb-0">{{month}}</h3>
                          </div>
                          <div class="w-6 text-right white-space-nowrap">
                              <h3 class="mb-0 text-sm">
                                  {{valueInMinorCurrencyForMonth(month) | currencyformat}}
                                  <span class="text-600 font-normal text-sm">{{ TotalDealsForMonth(month) | number}} {{'Shared.PIPELINE.DEALS' | translate}} </span>
                              </h3>
                          </div>
                      </div>
                  </ng-container>
                  <!-- Card Header -->
              </div>
              <!-- Cards Column -->
          </ng-container>
      </div>

      <ng-template #showSkeletonStage>
          <div class="flex flex-nowrap -mb-4 md:-mb-3 sales-pipeline-column-wrapper sticky top-0">
              <!-- Cards Column -->
              <div class="w-24rem mr-3 sales-pipeline-cards-column shadow-2" *ngFor="let board of numSequence(10)">
                  <!-- Card Header -->
                  <div class="card-header surface-0 p-3 border-round-top flex align-content-center">
                      <div class="w-6">
                          <p-skeleton width="100%" height="1.35rem"></p-skeleton>
                      </div>
                      <div class="w-6 text-right">
                          <div class="flex justify-content-end">
                              <p-skeleton width="3rem" height="1.35rem"></p-skeleton>
                              <p-skeleton styleClass="ml-2" width="3rem" height="1.35rem"></p-skeleton>
                          </div>
                      </div>
                  </div>
                  <!-- Card Header -->
              </div>
              <!-- Cards Column -->
          </div>
      </ng-template>

      <!-- Row -->
      <ng-container *ngIf="!showSkeleton; else showskeleton">
          <div class="sales-pipeline-cards-column-wrap overflow-auto" cdkScrollable class="flex flex-nowrap pb-3 mt-4 md:mt-0" *ngIf="showPipelineView.value && (opportunityData$ | async) as oppData$" cdkDropListGroup>
              <ng-container [ngTemplateOutlet]="cardDetails" [ngTemplateOutletContext]="{data:oppData$}"> </ng-container>
          </div>
          <div class="sales-pipeline-cards-column-wrap overflow-auto" class="flex flex-nowrap pb-3 mt-4 md:mt-0" *ngIf="showForecastView.value">
              <ng-container [ngTemplateOutlet]="cardDetailsForcastView" [ngTemplateOutletContext]="{data: foreCastBoardData}"> </ng-container>
          </div>
      </ng-container>
      <!-- Row -->

      <ng-template #showskeleton>
          <div class="sales-pipeline-cards-column-wrap overflow-auto" class="flex flex-nowrap pb-3 mt-4 md:mt-0">
              <div class="sales-pipeline-cards-column surface-0 p-3 md:mt-3 border-round-top-bottom mr-3 cursor-pointer-none" *ngFor="let card of numSequence(4); let i = index;">
                  <div class="surface-0 border-round-bottom">
                      <div class="sales-pipeline-card-wrap">
                          <!-- Card Body -->
                          <div class="card-body border-1 border-300 shadow-3 border-round p-3 pb-1 mb-3 sales-pipeline-card" *ngFor="let item of numSequence(i === 0 ? 3: i === 1 ? 2 : i === 3 ? 1:1 )">
                              <div class="flex align-items-center justify-content-between text-xs">
                                  <p-skeleton *ngIf="showSkeleton" width="4rem" height="1.35rem"></p-skeleton>
                                  <p-skeleton *ngIf="showSkeleton" width="6rem" height="1.35rem"></p-skeleton>
                              </div>

                              <div class="grid mt-3 mb-2">
                                  <div class="col-7">
                                      <div *ngIf="showSkeleton" class="mb-2 flex">
                                          <p-skeleton width="4rem" height="1.35rem"></p-skeleton>
                                          <p-skeleton styleClass="ml-2" width="3rem" height="1.35rem"></p-skeleton>
                                      </div>
                                  </div>
                                  <div class="col-5 text-right">
                                      <p-skeleton *ngIf="showSkeleton" styleClass="my-1" width="6rem" height="1.35rem"></p-skeleton>
                                  </div>
                              </div>

                              <div class="card-body-btn transition-all mt-3 border-round px-1 text-yellow-600">
                                  <div *ngIf="showSkeleton" class="flex align-items-center p-1">
                                      <p-skeleton styleClass="mr-1 border-circle" width="2rem" height="2rem"></p-skeleton>
                                      <div class="w-10rem">
                                          <p-skeleton styleClass="mb-1" width="100%" height="1.35rem"></p-skeleton>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <!-- Card Body -->
                      </div>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>

  <ng-template #cardDetails let-oppData$="data">
      <!-- Cards Column -->
      <div class="sales-pipeline-cards-column surface-0 p-3 md:mt-3 border-round-top-bottom mr-3"
          *ngFor="let board of oppData$;let boardIndex = index;"
          cdkDropList
          [cdkDropListConnectedTo]="connectedDropLists"
          [cdkDropListAutoScrollDisabled]="false"
          [cdkDropListAutoScrollStep]="20"
          [cdkDropListData]="board.opportunity"
          (cdkDropListDropped)="leadsOnDrop($event, board.id )"
          [attr.data-testid]="'pipeline-column-' + boardIndex"
      >
          <div class="surface-0 border-round-bottom">
              <div class="sales-pipeline-card-wrap">
                  <!-- Card Body -->

                  <div
                      *ngFor="let opportunity of parseMap(board.opportunity)"
                      [id]="opportunity.id"
                      (cdkDragStarted)="leadOnDragStart($event)"
                      (cdkDragReleased)="leadOnDragRelease($event)"
                      (cdkDragEnded)="leadOnDragEnded($event)"
                      (cdkDragMoved)="dragMovescroll($event)"
                      [cdkDragStartDelay]="100"
                      cdkDrag
                      autoScrollDisabled="true"
                      class="card-body surface-0 border-1 border-round p-1 mb-3 sales-pipeline-card shadow-3 hover:shadow-7 transition-duration-300 transition-all sales-pipeline-card cursor-move"
                      [ngClass]="dragStatus(opportunity.id) + '  ' + taskStatus(opportunity.latest_task)"
                      (click)="SetOutComeDetails($event,opportunity)"
                      [attr.data-testid]="'opportunity-' + opportunity.id"
                      >
                      <div class="p-1 mb-3 sales-pipeline-card-preview dragging border-round border-2 border-dashed border-primary bg-blue-50" *cdkDragPlaceholder></div>
                      <ng-container [ngTemplateOutlet]="opportunityDetails" [ngTemplateOutletContext]="{data:opportunity}"> </ng-container>
                  </div>
              </div>
              <!-- Cards Column -->
          </div>
      </div>
      <!-- Cards Column -->

      <!-- Drag Drop Card -->
      <div class="pipeline-drop-card col-12 md:col-7 lg:col-6 xl:col-4 fixed left-50 bottom-0 mb-6 xl:mb-4 md:ml-5 lg:ml-7 xl:ml-8 z-1" [hidden]="!showLostDealDialog">
          <div class="overflow-y-auto surface-800 text-white border-round flex">
              <!-- Lost -->
              <div
                  class="w-6 p-1 md:p-2 border-right-1 border-300 lostOwnDealCont"
                  cdkDropList
                  #lostElement
                  [cdkDropListConnectedTo]="connectedDropLists"
                  [cdkDropListData]="getAllBoardData"
                  (cdkDropListEntered)="dragEnterToLostDeal($event)"
                  (cdkDropListExited)="dragExitFromLostDeal($event)"
                  (cdkDropListDropped)="moveToLostDeal($event)"
                  cdkDropListSortingDisabled="true"
                  [attr.data-testid]="'lost-deal-column'"
              >
                  <div class="h-full flex p-2 cursor-pointer hover:surface-700 lostOwnDealWrap" [ngClass]="dragStatusOnLost">
                      <i class="fa fa-user-large-slash hidden md:block"></i>
                      <div class="ml-2">
                          <h4 class="text-base md:text-xl font-bold mb-0">{{'Shared.PIPELINE.LOST' | translate}}</h4>
                          <p class="text-xs md:text-sm mb-0 opacity-80">{{'Shared.PIPELINE.DRAG_LOST' | translate}}</p>
                      </div>
                  </div>
              </div>
              <!-- Lost -->
              <!-- Won -->
              <div
                  class="w-6 p-1 md:p-2 border-right-1 border-300 cursor-pointer lostOwnDealCont"
                  cdkDropList
                  #ownElement
                  [cdkDropListConnectedTo]="connectedDropLists"
                  [cdkDropListData]="getAllBoardData"
                  (cdkDropListEntered)="dragEnterToWinDeal($event)"
                  (cdkDropListExited)="dragExitFromWinDeal($event)"
                  (cdkDropListDropped)="moveToWonDeal($event)"
                  cdkDropListSortingDisabled="true"
                  [attr.data-testid]="'won-deal-column'"
              >
                  <div class="h-full flex p-2 cursor-pointer hover:surface-700 lostOwnDealWrap" [ngClass]="dragStatusOnOwn">
                      <i class="fa fa-user-plus hidden md:block"></i>
                      <div class="ml-2">
                          <h4 class="text-base md:text-xl font-bold mb-0">{{'Shared.PIPELINE.WON' | translate}}</h4>
                          <p class="text-xs md:text-sm mb-0 opacity-80">{{'Shared.PIPELINE.DRAG_WON' | translate}}</p>
                      </div>
                  </div>
              </div>
              <!-- Won -->
          </div>
      </div>
      <!-- Drag Drop Card -->
  </ng-template>

  <ng-template #cardDetailsForcastView let-foreCastBoardData="data">
      <!-- Cards Column -->
      <div class="sales-pipeline-cards-column surface-0 p-3 md:mt-3 border-round-top-bottom mr-3" *ngFor="let month of filterMonths$ | async">
          <div class="surface-0 border-round-bottom">
              <div class="sales-pipeline-card-wrap">
                  <!-- Card Body -->

                  <div
                      *ngFor="let opportunity of foreCastBoardData.get(month)"
                      [id]="opportunity.id"
                      class="card-body surface-0 border-1 border-round p-1 mb-3 sales-pipeline-card shadow-3 hover:shadow-7 transition-duration-300 transition-all sales-pipeline-card cursor-move"
                      [ngClass]="taskStatus(opportunity.latest_task)"
                      (click)="SetOutComeDetails($event,opportunity)"
                      [attr.data-testid]="'opportunity-' + opportunity.id"
                  >
                      <ng-container [ngTemplateOutlet]="opportunityDetails" [ngTemplateOutletContext]="{data:opportunity}"> </ng-container>
                  </div>
              </div>
              <!-- Cards Column -->
          </div>
      </div>
      <!-- Cards Column -->
  </ng-template>

  <!-- Empty State -->
  <ng-container *ngIf="(showEmptyPipeline$ | async) && !showSkeleton">
      <div class="text-center my-4">
          <h3 class="text-xl font-bold mb-2 mt-5 md:mt-8">{{'Shared.PIPELINE.EMPTY_PIPELINE' | translate}}</h3>
          <button pButton pRipple type="button" (click)="showCreateOpportunityPopup = true;" icon="fa fa-plus" label="{{'Shared.PIPELINE.ADD_FIRST_OPPORTUNITY' | translate}}" class="p-button-text" aria-label="add-first-opportunity-button"></button>
          <img class="block mx-auto" width="500" src="/assets/img/empty-favorite-img.svg" alt="Image" />
      </div>
  </ng-container>
  <!-- Empty State -->

  <ng-template #opportunityDetails let-opportunity="data">
      <div class="px-2 pt-2" *ngIf="opportunity">
          <h5 class="text-sm mb-3">{{opportunity?.name}}</h5>
          <div class="flex align-items-center justify-content-between text-xs">
              <hotwarmcold [status]="opportunity.hot_warm_cold" class="-ml-1"></hotwarmcold>
              <strong class="text-base">{{opportunity?.value_in_minor_currency | currencyformat }}</strong>
          </div>

          <div class="flex mt-3 mb-2">
              <div class="w-7">
                  <h4 class="text-primary text-sm mb-2">
                      {{opportunity?.client_info?.full_name}}
                      <span class="text-600 font-normal text-xs"> - {{opportunity?.client_info?.id}}</span>
                  </h4>
              </div>
              <div class="w-5 text-right" [innerHTML]="clientStatus(opportunity.client_info)"></div>
          </div>
          <ul class="list-none md:block m-0 p-0">
              <li class="mb-2" *ngFor="let m of opportunity.service_type">
                  <span class="bg-blue-50 text-primary uppercase font-bold py-1 px-2 border-round text-xxs" *ngIf="m.name_primary_language">{{m.name_primary_language}}</span>
                  <span class="bg-blue-50 text-primary uppercase font-bold py-1 px-2 border-round text-xxs" *ngIf="!m.name_primary_language">{{m.name_secondary_language}}</span>
              </li>
          </ul>
      </div>
      <!-- Card Body -->

      <div
          class="card-body-btn transition-all mt-3 border-round px-1 mt-4"
          [ngClass]="taskStatusBackground(opportunity.latest_task)"
          *ngIf="opportunity.latest_task && opportunity.latest_task.status.toLowerCase() === 'scheduled'"
          (click)="SetOutComeDetails($event,opportunity);"
          data-testid="opportunity-task-button"
      >
          <div class="grid align-items-center w-100 white-space-nowrap">
              <div class="col-9">
                  <div class="flex">
                      <div class="ml-1">
                          <div class="font-normal">
                              <i class="fa" [class]="displayTaskTypeIcon(opportunity)"></i>
                              {{opportunity.latest_task.type}}
                              <strong>{{(opportunity.latest_task.scheduled_date | TimeLine).task_label }}</strong>
                          </div>
                          <div class="text-xs text-600 ml-3 mt-1 pl-1" *ngIf="opportunity.latest_task && getStaffDetails(opportunity.latest_task.assigned_to_staff_id)">
                              {{getStaffDetails(opportunity.latest_task.assigned_to_staff_id).name}}
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-3 text-right" *ngIf="opportunity.latest_task && getStaffDetails(opportunity.latest_task.assigned_to_staff_id).ff_picture;else no_image  ">
                  <p-avatar [image]="getStaffDetails(opportunity.latest_task.assigned_to_staff_id).ff_picture" styleClass="p-mr-2"> </p-avatar>
              </div>
              <ng-template #no_image>
                  <div class="col-3 text-right">
                      <p-avatar [label]="getStaffDetails(opportunity.latest_task.assigned_to_staff_id).name | titlecase | shortName" styleClass="p-mr-2"></p-avatar>
                  </div>
              </ng-template>
          </div>
      </div>
      <div class="card-body-btn transition-all mt-3 border-round px-1 mt-3 bg-yellow-100 text-yellow-600" *ngIf="!opportunity.latest_task" (click)="createTask($event,opportunity)">
          <div class="flex align-items-center p-1">
              <i class="fa fa-exclamation-triangle mr-3"></i>
              <span>
                  {{'Shared.PIPELINE.NO_TASK_ASSIGNED' | translate}} <br />
                  <strong class="cursor-pointer">{{'Shared.PIPELINE.ADD_TASK' | translate}}</strong>
                  {{'Shared.PIPELINE.FOR_OPPORTUNITY' | translate}}
              </span>
          </div>
      </div>
  </ng-template>

  <!-- Body Content-->
</div>


<!-- Close Task Modal  -->
<p-dialog [(visible)]="taskModalPopup" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}" styleClass="no-header-modal" [closeOnEscape]="true">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <!-- Content -->
      <div class="relative text-center py-7 px-5">
          <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer" (click)="taskModalPopup = false"></div>

          <i class="fa fa-exclamation-triangle p-error text-8xl"></i>
          <p class="my-6 text-lg line-height-2">
              {{'Shared.PIPELINE.DO_YOU_WANT' | translate}} <strong>{{'Shared.PIPELINE.CLOSE_THE_TASK' | translate}}</strong> {{'Shared.PIPELINE.LINKED_TO_OPPORTUNITY' | translate}}
              <strong *ngIf="planSummarydataObject$ | async as planSummary;">
                  {{planSummary.client.client_name}}
              </strong>
              ?
          </p>
          <button pButton pRipple type="button" label="{{'Shared.PIPELINE.YES_CONTINUE' | translate}}" class="text-sm w-15rem" (click)="closeTaskModal(true)" aria-label="yes-continue-button"></button>
          <br />
          <button pButton pRipple type="button" label="{{'Shared.PIPELINE.NO_CONTINUE' | translate}}" class="p-button-danger mt-3 text-sm w-15rem" (click)="closeTaskModal(false)" aria-label="no-continue-button"></button>
      </div>
      <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Close Task Modal -->

<!-- Choose Reason Modal  -->
<app-lost-deal [showDailog]="showChooseReason" (closeMainDailog)="closeDailog()" [lostDealInfo]="lostDealItemInfo" (reload)="reloadAllData()" aria-label="choose-reason-modal"> </app-lost-deal>
<!-- Choose Reason Modal -->

<create-opportunity *ngIf="showCreateOpportunityPopup" [visible]="showCreateOpportunityPopup" [clientInfo]="[]" (hidePopup)="hideOpportunity($event)" [opportunity]="dataOpportunityResponse"> </create-opportunity>

<app-call-outcome *ngIf="showCallOutcomePopup" [visible]="showCallOutcomePopup" [data]="outcomeDetail" (hideOutCome)="HideOutComePopup($event)" (modified)="modified($event)" (showClientProfile)="GoToClientDetails($event)">
</app-call-outcome>

<app-tour-outcome *ngIf="showMeetingOutcomePopup" [visible]="showMeetingOutcomePopup" [tourOutComeData]="outcomeDetail" (hideOutCome)="HideOutComePopup($event)" (modified)="modified($event)" (showClientProfile)="GoToClientDetails($event)">
</app-tour-outcome>

<task-create
  *ngIf="showTaskCreate"
  [visible]="showTaskCreate"
  [cltIds]="[activeTaskOpportunity.client_info?.id]"
  [oppIds]="[activeTaskOpportunity.id]"
  [opportunity]="activeTaskOpportunity"
  (createdTask)="taskCreated($event)"
  (hide)="HideTaskCreate($event)"
  (TaskCreateType)="TaskCreateType.Single"
  (openClientProfile)="openClientDetails($event)"
>
</task-create>

<billing *ngIf="showPaidFullSidebar" [visible]="showPaidFullSidebar" [planSummarydata]="planSummarydataObject$" [showBilling]="showPaidFullSidebar" closeOnEscape="false" (closeSidePopupMember)="hideBillingSummary($event)"> </billing>

<client-info-sidebar *ngIf="showClientSidebar" [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId" (closeSidebar)="closeSidebar($event)"> </client-info-sidebar>
<!-- </ion-content> -->
